export default __webpack_public_path__ + "static/media/lightingCategory.0d550b5f.jpeg";